define(
    'NMSDesignSystem.GlobalStates',
    [
        'GlobalViews.Modal.View',
        'nms_global_views_modal.tpl'
    ],
    function NMSDesignSystemGlobalStates(GlobalViewsModalView, nmsGlobalViewsModalTpl) {
        'use strict';

        var pilotClass = 'nms-global-states-pilot';
        var buttonObserver;
        var filledButtonSelector = [
            '.nms-button--primary',
            '.cart-detailed-proceed-to-checkout',
            '.login-register-login-submit',
            '.custom-register-form-submit',
            '.login-register-register-form-submit',
            '.order-wizard-address-module-save-button',
            '.order-wizard-cart-summary-button-place-order',
            '.creditcard-edit-form-button-submit',
            '.paymentinstrument-creditcard-edit-form-button-submit',
            '.quick-add-box-button',
            '[class^="contact-us-form-"][class$="-submit-button"]',
            '.myaccount-layout #content button[type="submit"]',
            '.nms-account-layout #content button[type="submit"]',
            '.balance-continue-button:not([disabled])',
            '.invoice-open-list-button-payment:not([disabled])',
            '.global-views-confirmation-confirm-button',
            '.error-management-expired-link-login-button',
            '.order-wizard-confirmation-module-continue',
            '.payment-wizard-confirmation-module-payment',
            '.quote-to-salesorder-wizard-module-confirmation-continue'
        ].join(',');
        var iconPaths = {
            check: ['M20 6 9 17l-5-5'],
            plus: ['M5 12h14', 'M12 5v14'],
            download: ['M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', 'm7 10 5 5 5-5', 'M12 15V3'],
            send: ['m22 2-7 20-4-9-9-4Z', 'M22 2 11 13'],
            login: ['M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4', 'm10 17 5-5-5-5', 'M15 12H3'],
            arrow: ['M5 12h14', 'm12 5 7 7-7 7']
        };

        GlobalViewsModalView.prototype.template = nmsGlobalViewsModalTpl;

        function getButtonIcon(button, label) {
            var configured = button.getAttribute('data-nms-button-icon');
            var text = String(label || '').toLowerCase();

            if (configured && iconPaths[configured]) {
                return configured;
            }
            if (/download|pdf/.test(text)) {
                return 'download';
            }
            if (/reply|send/.test(text)) {
                return 'send';
            }
            if (/log in|login|sign in/.test(text)) {
                return 'login';
            }
            if (/^submit new|^add\b|^new\b|^create\b/.test(text)) {
                return 'plus';
            }
            if (/checkout|continue|view|detailed page|next|recover|reset password/.test(text)) {
                return 'arrow';
            }

            return 'check';
        }

        function createIcon(iconName) {
            var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

            svg.setAttribute('class', 'nms-button__icon lucide lucide-' + (iconName === 'login' ? 'log-in' : iconName === 'arrow' ? 'arrow-right' : iconName));
            svg.setAttribute('viewBox', '0 0 24 24');
            svg.setAttribute('aria-hidden', 'true');
            svg.setAttribute('focusable', 'false');
            svg.setAttribute('fill', 'none');
            svg.setAttribute('stroke', 'currentColor');
            svg.setAttribute('stroke-width', iconName === 'check' ? '2.5' : '2');
            svg.setAttribute('stroke-linecap', 'round');
            svg.setAttribute('stroke-linejoin', 'round');
            iconPaths[iconName].forEach(function appendPath(pathData) {
                var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

                path.setAttribute('d', pathData);
                svg.appendChild(path);
            });

            return svg;
        }

        function enhanceButton(button) {
            var labelElement;
            var iconElement;
            var label;
            var iconName;

            if (!button || button.tagName === 'INPUT') {
                return;
            }

            labelElement = button.querySelector('.nms-button__label');
            iconElement = button.querySelector('.nms-button__icon, .nms-button__slide-icon');

            if (
                button.getAttribute('data-nms-slide-enhanced') === 'true' &&
                labelElement &&
                iconElement
            ) {
                return;
            }

            label = labelElement ? labelElement.textContent.trim() : button.textContent.trim();

            if (!label) {
                return;
            }

            iconName = getButtonIcon(button, label);
            button.setAttribute('data-nms-filled-button', 'true');
            button.setAttribute('data-nms-slide-enhanced', 'true');
            button.classList.add('nms-button');
            button.classList.add('nms-button--primary');
            button.classList.add('nms-button--slide-icon');

            if (!labelElement) {
                button.textContent = '';
                labelElement = document.createElement('span');
                labelElement.className = 'nms-button__label';
                labelElement.textContent = label;
                button.appendChild(labelElement);
            }

            if (!iconElement) {
                button.appendChild(createIcon(iconName));
            }
        }

        function enhanceButtons(root) {
            var buttons = [];

            if (!root || !root.querySelectorAll) {
                return;
            }
            if (root.matches && root.matches(filledButtonSelector)) {
                buttons.push(root);
            }
            buttons = buttons.concat(Array.prototype.slice.call(root.querySelectorAll(filledButtonSelector)));
            buttons.forEach(enhanceButton);
        }

        function installButtonObserver() {
            if (buttonObserver || !window.MutationObserver || !document.body) {
                return;
            }

            buttonObserver = new window.MutationObserver(function buttonsChanged(records) {
                records.forEach(function inspectRecord(record) {
                    if (record.target && record.target.nodeType === 1) {
                        enhanceButtons(record.target);
                    }
                    Array.prototype.forEach.call(record.addedNodes || [], function inspectNode(node) {
                        if (node.nodeType === 1) {
                            enhanceButtons(node);
                        }
                    });
                });
            });
            buttonObserver.observe(document.body, {childList: true, subtree: true});
        }

        function allowViewportZoom() {
            var viewport = document.querySelector('meta[name="viewport"]');
            if (!viewport) return;
            var current = viewport.getAttribute('content') || '';
            var content = current.split(',').filter(function keepViewportDirective(directive) {
                return !/^\s*(maximum-scale|user-scalable)\s*=/i.test(directive);
            }).join(',');
            if (current !== content) viewport.setAttribute('content', content);
        }

        function sync() {
            allowViewportZoom();
            if (document.body) {
                document.body.classList.add(pilotClass);
                enhanceButtons(document);
                installButtonObserver();
            }
        }

        return {
            enhanceButton: enhanceButton,
            mountToApp: function mountToApp(container) {
                var layout = container && container.getComponent
                    ? container.getComponent('Layout')
                    : null;

                sync();

                if (layout) {
                    layout.on('afterShowContent', sync);
                }
            }
        };
    }
);
